import React from "react";
import { Col, Row } from "antd";

interface ServerSidePaginationProps {
  currentPage: number;
  totalPages: number;
  canGoPrevious: boolean;
  canGoNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  isLoading?: boolean;
}

const ServerSidePagination = ({
  currentPage,
  totalPages,
  canGoPrevious,
  canGoNext,
  onPrevious,
  onNext,
  isLoading = false,
}: ServerSidePaginationProps) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <Row>
      <Col span={24} style={{ textAlign: "right" }} className="pagination-container">
        <ul className={`ant-pagination unified-pagination ${isLoading ? "ant-pagination-disabled" : ""}`}>
          <li
            className={`ant-pagination-prev ${
              !canGoPrevious || isLoading ? "ant-pagination-disabled" : ""
            }`}
            aria-disabled={!canGoPrevious || isLoading}
          >
            <button
              type="button"
              className="ant-pagination-item-link"
              onClick={onPrevious}
              disabled={!canGoPrevious || isLoading}
            >
              <span className="nav-buttons">Previous</span>
            </button>
          </li>

          <li className="ant-pagination-item ant-pagination-item-active server-pagination-label-cell">
            <a>{`Page ${currentPage} of ${totalPages}`}</a>
          </li>

          <li
            className={`ant-pagination-next ${
              !canGoNext || isLoading ? "ant-pagination-disabled" : ""
            }`}
            aria-disabled={!canGoNext || isLoading}
          >
            <button
              type="button"
              className="ant-pagination-item-link"
              onClick={onNext}
              disabled={!canGoNext || isLoading}
            >
              <span className="nav-buttons">Next</span>
            </button>
          </li>
        </ul>
      </Col>
    </Row>
  );
};

export default ServerSidePagination;
